module.exports = __webpack_public_path__ + "static/img/diy-restart.26e0394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/reformat/diy-restart.png
// module id = MinI
// module chunks = 0